import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { NavigationState } from 'src/app/models/navigation/navigation-state';
import { endNavigate } from 'src/app/reducers/navigation/navigation.actions';
import { UserService } from 'src/app/services/user/user.service';
import { PermissionService } from 'src/app/services/user/permission.service';
import { InternationalizationService } from 'src/app/services/utils/Internationalization.service';
import { Center } from 'src/app/models/center/center';
import { FrogedService } from 'src/app/services/froged-service';
import { setSupportButton } from 'src/app/reducers/navigation/navigation.actions';
import { ClarityService } from '@services/index';
@Component({
    selector: 'app-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {

    private DEFAULT_HOUR_FORMAT_24 = 'HH:mm';
    private DEFAULT_HOUR_FORMAT_12 = 'h:mm a';

    hidden = false;
    fullScreen = false;
    topFlag = false;
    tintColor = '#108ee9';
    unselectedTintColor = '#888';
    tabbarStyle: object = { height: '400px' };
    selectedIndex = 1;
    centers: Center[] = [];
    myCenter!: Center;
    hubspotWidgetCloseEvent: any;
    constructor(private readonly router: Router,
                private readonly store: Store<{ navigation: NavigationState }>,
                private readonly userService: UserService,
                private readonly internationalizationService: InternationalizationService,
                private readonly translateService: TranslateService,
                private readonly frogedService: FrogedService,
                private readonly clarityService: ClarityService){
        this.store.select(data => data.navigation).subscribe(data => {
            if (data.navigate) {
                void this.router.navigateByUrl(data.url).then(() => this.store.dispatch(endNavigate()));
            }
        });
    }

    ngOnInit(): void {
        this.centers = this.userService.getCenters();
        this.myCenter = this.userService.getCenter();
        const codeLanguage = this.userService.getUser().language.codeLanguage;
        const code = codeLanguage.split('_')[0];
        this.internationalizationService.setLanguage(codeLanguage);
        this.internationalizationService.setLocale(code);
        this.centers.forEach(savedCenter => {
            if (savedCenter.center.id === this.myCenter.center.id) {
                this.myCenter = savedCenter;
            }
        });
        if (this.userService.getCenter().permissions.supportType === 3) {
            this.loadHubSpot();
        }
        if (this.myCenter.regionalConfiguration) {
            this.internationalizationService.setFirstDayOfWeek(this.myCenter.regionalConfiguration.firstWeekDay % 7);
            this.internationalizationService.setDateFormat(this.myCenter.regionalConfiguration.date);
            if (this.myCenter.regionalConfiguration.showMeridian) {
                this.internationalizationService.setHourFormat(this.DEFAULT_HOUR_FORMAT_12);
            } else {
                this.internationalizationService.setHourFormat(this.DEFAULT_HOUR_FORMAT_24);
            }
        }

        this.internationalizationService.importLocale();
        moment.updateLocale(code, null);

        this.translateService.use(codeLanguage);

        const user = this.userService.getUser();
        const center = this.userService.getCenter();
        const permissionFull = this.userService.getPermissions();
        const idStaff = user.staff.id;

        // Frogged
        try {
            const dataInfo = {
                user_id: idStaff,
                role: permissionFull?.staffPermissionFull.staffPermission.category,
                permission: permissionFull?.staffPermissionFull.staffPermission.permission,
                accountId: idStaff,
                firstName: user.staff.name,
                lastname: user.staff.lastName,
                centerName: center.center.name,
                email: user.staff.email,
                country: center.worldLocation.country,
                enterprise: center.center.enterprise.name,
                modules: center.modules.modules,
                centerSubscription: center.center.centerSubscription,
                centerSubcriptionType: center.center.centerSubcriptionType,
                currentCenterType: center.center.centerType,
                idCenter: center.center.id,
                city: center.worldLocation.city,
                dateRegistration: user.staff.dateCreationStaff,
                modulesName: center.modules.modulesName,
                staffWish: center.center.staffWish,
                businessType: center.center.businessType,
                businessCategory: center.center.businessCategory,
                tokenStaff: user.staff.token
            };
            this.frogedService.loadUserFrogged(dataInfo);
            this.clarityService.loadUserClarity(dataInfo);
        } catch (e) {
            console.log(e, 'Can not load Mixpanel');
        }
    }
    private loadHubSpot(): void {
        this.userService.getVisitorToken().subscribe(
            (response) => {
                try {
                    if ((window as any).HubSpotConversations) {
                        (window as any).HubSpotConversations.clear({resetWidget : true});
                        (window as any).hsConversationsSettings.identificationEmail = response.email;
                        (window as any).hsConversationsSettings.identificationToken = response.token;
                        if (!this.hubspotWidgetCloseEvent){
                            this.hubspotWidgetCloseEvent = (window as any).HubSpotConversations.on('widgetClosed', () => {
                                (window as any).HubSpotConversations.widget.remove();
                            });
                        }
                        this.store.dispatch(setSupportButton({value: true}));
                    }
                } catch (e) { }
            }, () => this.store.dispatch(setSupportButton({value: false}))
        );
    }
}
